import { Tab, Tabs } from 'vant'
import { Component, Mixins, Prop } from 'vue-property-decorator'
import { SuperMixin } from '../../category.mixin'
import { DiscountsMixin } from '@shared/mixins/discounts'
import Consultant from '../consultantGrayScale/consultant.vue'
import { namespace } from 'vuex-class'
const categoryModule = namespace('category')

import { flatMap, includes, intersectionWith, map, join, filter, find } from 'lodash'
import { CARESSTUINA } from '@constant/index'
import { routerPush, toV } from '@utils/index'
import { AsyncStatus } from '@constant/index'
@Component({
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    Consultant
  }
})
export default class SelfOperatedComponent extends Mixins(DiscountsMixin, SuperMixin) {
  [x: string]: any
  public tabSelect:string | undefined = ''

  @Prop() hasConfition!:any

  get showConsultant(){
    return this.hasConfition === AsyncStatus.HAS
  }

  @categoryModule.State categoryList!: any[]
  @categoryModule.State selfOperatedData!: any

  get nearStore() {
    return this.selfOperatedData && this.selfOperatedData.nearStore
  }

  get consultantList() {
    return this.selfOperatedData && this.selfOperatedData.worker
  }

  get spuList() {
    return this.selfOperatedData && this.selfOperatedData.spuList
  }
  get spuIds() {
    return this.spuList && map(this.spuList, (o: any) => o.spuId)
  }
  // get tabCategoryList() {
  //   const categoryHasIds = includes(CARESSTUINA, this.categoryId)
  //   const list = categoryHasIds ? CARESSTUINA : [this.categoryId]
  //   return intersectionWith(this.categoryList, list, (pre: any, next: string) => pre.value == next)
  // }

  get selfCmmtyList() {
    const categoryHasIds = includes(CARESSTUINA, this.categoryId)
    const list = categoryHasIds ? CARESSTUINA : this.categoryId && this.categoryId.length === 8 ? [this.categoryId] : this.categoryIds
    const tabCategoryList = intersectionWith(this.categoryList, list || [], (pre: any, next: string) => pre.value == next)
    const arr = flatMap(tabCategoryList, (item: any) => {
      item.children = filter(this.spuList, (o: any) => o.level4CategoryId == item.value)
      return item.children && item.children.length > 0 ? [item] : []
    })
    if (!find(arr, (item: any) => item.value == this.tabSelect) && arr.length > 0) {
      this.tabSelect = arr[0].value
    }
    return arr
  }

  mounted() {
    this.tabSelect = this.categoryId
  }

  changeTag(value: string) {
    this.tabSelect = value
  }

  get hasSelfOperated() {
    return this.spuList && this.spuList.length > 0
  }

  hasDiscounts(item: any) {
    return item.source == 1 ? item.promotionName : item.source == 2 ? item.couponName : null
  }
  handleMore() {
    const spuIds = join(this.spuIds, ',')
    const { refresh } = this.$route.query
    routerPush({ name: 'consultantList', query: { spuIds, refresh } })
  }
  toProduct(item: any) {
    const { spuId } = item
    toV({ name: 'product-detail', params: { spuId }, query: { refresh: 'no' } })
  }
  toStore(stroe: any) {
    location.href = `//w.cekid.com/store/info.html?code=${stroe.storeId}`
  }
}
